<template>
    <Index/>
</template>

<script>
  
  import Index from '@/components/login/Index.vue';
  
  export default {
    name:'login',
    components:{
      Index
    }
  }

</script>